var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconManageSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2889_12203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 6.41667C7.33594 7.38913 7.72225 8.32176 8.40988 9.00939C9.09751 9.69703 10.0301 10.0833 11.0026 10.0833C11.9751 10.0833 12.9077 9.69703 13.5953 9.00939C14.283 8.32176 14.6693 7.38913 14.6693 6.41667C14.6693 5.44421 14.283 4.51158 13.5953 3.82394C12.9077 3.13631 11.9751 2.75 11.0026 2.75C10.0301 2.75 9.09751 3.13631 8.40988 3.82394C7.72225 4.51158 7.33594 5.44421 7.33594 6.41667Z",
    stroke: "#798399",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.25V17.4167C5.5 16.4442 5.88631 15.5116 6.57394 14.8239C7.26157 14.1363 8.19421 13.75 9.16667 13.75H10.5417",
    stroke: "#798399",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6953 16.0443C14.6953 16.5305 14.8885 16.9968 15.2323 17.3406C15.5761 17.6844 16.0424 17.8776 16.5286 17.8776C17.0149 17.8776 17.4812 17.6844 17.825 17.3406C18.1688 16.9968 18.362 16.5305 18.362 16.0443C18.362 15.558 18.1688 15.0917 17.825 14.7479C17.4812 14.4041 17.0149 14.2109 16.5286 14.2109C16.0424 14.2109 15.5761 14.4041 15.2323 14.7479C14.8885 15.0917 14.6953 15.558 14.6953 16.0443Z",
    stroke: "#798399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 12.8359V14.2109",
    stroke: "#798399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 17.875V19.25",
    stroke: "#798399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3079 14.4375L18.1172 15.125",
    stroke: "#798399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9417 16.9609L13.75 17.6484",
    stroke: "#798399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 14.4375L14.9417 15.125",
    stroke: "#798399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1172 16.9609L19.3089 17.6484",
    stroke: "#798399",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2889_12203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManageSystem);
export default __webpack_public_path__ + "static/media/icon-manage-system.4184b5b9f0e49d0b8df5930ab27a14d9.svg";
export { ForwardRef as ReactComponent };